
    import React from 'react';
    import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
    import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
    import SpriteSymbolComponent from "../../components/Svg/Icon.js";
    
    const symbol = new SpriteSymbol({
  "id": "exclamation-green--sprite",
  "use": "exclamation-green--sprite-usage",
  "viewBox": "0 0 26 26",
  "content": "<symbol viewBox=\"0 0 26 26\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"exclamation-green--sprite\"><path d=\"M13 7v7m12-1c0 6.627-5.373 12-12 12S1 19.627 1 13 6.373 1 13 1s12 5.373 12 12zm-11.25 5a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0z\" stroke=\"url(#exclamation-green--sprite_exclamation-green_svg__a)\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /><defs><linearGradient id=\"exclamation-green--sprite_exclamation-green_svg__a\" x1=\"1\" y1=\"13.179\" x2=\"25\" y2=\"13.179\" gradientUnits=\"userSpaceOnUse\"><stop stop-color=\"#4AC1E0\" /><stop offset=\"1\" stop-color=\"#6BC049\" /></linearGradient></defs></symbol>"
});
    sprite.add(symbol);

    export default class ExclamationGreenSpriteSpriteSymbolComponent extends React.Component {
      render() {
        return <SpriteSymbolComponent glyph="exclamation-green--sprite" viewBox="0 0 26 26" {...this.props} />;
      }
    }
  